import {
  DEFAULT_PRIMARY_LANGUAGE,
  normalizeAppLanguageKey,
  withPrimaryLanguageFromAuth,
} from "./appLanguages";

/** Read a property from API auth payload (camelCase or PascalCase). */
function pick(data, camelKey, pascalKey) {
  if (!data || typeof data !== "object") return undefined;
  if (data[camelKey] !== undefined && data[camelKey] !== null) return data[camelKey];
  if (data[pascalKey] !== undefined && data[pascalKey] !== null) return data[pascalKey];
  return undefined;
}

/**
 * Maps Account auth response (`Login`, `Register`, `GoogleAuth`, etc.) to client storage shape.
 * API shape includes `PrimaryLanguage`, `SelfUserId`, `CompanyInfo`, etc.
 */
export function parseAuthResponseData(data, overrides = {}) {
  if (!data || typeof data !== "object") {
    return null;
  }

  const accessToken = pick(data, "accessToken", "AccessToken");
  const refreshToken = pick(data, "refreshToken", "RefreshToken");
  const tokenExpire = pick(data, "tokenExpire", "TokenExpire");
  const roles = pick(data, "roles", "Roles");
  const name = pick(data, "name", "Name");
  const email = overrides.email ?? pick(data, "email", "Email");
  const selfUserId = pick(data, "selfUserId", "SelfUserId");
  const roleId = pick(data, "roleId", "RoleId");
  const companyInfo = pick(data, "companyInfo", "CompanyInfo");
  const isAnnualLeavePopupShown =
    pick(data, "isAnnualLeavePopupShown", "IsAnnualLeavePopupShown") ?? false;
  const hasPassword = pick(data, "hasPassword", "HasPassword");
  const approverId = pick(data, "approverId", "ApproverId");
  const primaryLanguageRaw = pick(data, "primaryLanguage", "PrimaryLanguage");

  const userInfo = withPrimaryLanguageFromAuth(
    {
      name,
      roles,
      email,
      selfUserId,
      hasPassword: hasPassword !== undefined ? hasPassword : true,
      approverId: approverId ?? null,
      ...(primaryLanguageRaw != null && {
        primaryLanguage: normalizeAppLanguageKey(primaryLanguageRaw),
      }),
    },
    data
  );

  const authData = {
    accessToken,
    refreshToken,
    ...(tokenExpire != null ? { tokenExpire } : {}),
  };

  return {
    userInfo,
    authData,
    roleId,
    companyInfo,
    isAnnualLeavePopupShown,
    primaryLanguage:
      userInfo.primaryLanguage ||
      normalizeAppLanguageKey(primaryLanguageRaw) ||
      DEFAULT_PRIMARY_LANGUAGE,
  };
}
